import axios from 'axios';
import API_HOST from '../api';

/**
 * product related api interface
 */
const productApi = function() {
  const api = {};

  /**
   * get a list of all the products available even products
   * the client might not have
   */
  api.getAllProductTypes = function() {
    const url = `${API_HOST}/api/product-list`;
    return axios.get(url);
  };

  return api;
};

export default productApi();
